import { useForm } from "react-hook-form";

import { useEffect, useState } from "react";
import WalletForm from "./WalletForm";
import UsersForm from "./UsersForm";
import UserInfoForm from "./UserInfoForm";

type Props = {
    id: number;
    removeAnimation?: () => void;
    type?: 'new' | 'edit'|'duplicate'|'view';
    tableId?: number;
    rowData?:any;
   page?:'wallet'|'users'|'userInfo'
  }
function WalletSidebar({id, removeAnimation, type = 'new', tableId,rowData,page='wallet'}: Props) {
     const [actionType,setActionType] = useState<'new' | 'edit'|'duplicate'|'view'>('new')
     useEffect(()=>{
        setActionType(type)
     },[type,tableId])
   
  return (
    <>
        {page === 'wallet'&&<WalletForm type={actionType} removeAnimation={removeAnimation} rowId={tableId} rowData={rowData}/>}
       {page === 'users'&& <UsersForm type={actionType} removeAnimation={removeAnimation} rowId={tableId}/>}
       {page === 'userInfo' && <UserInfoForm type={actionType} removeAnimation={removeAnimation} rowId={tableId} rowData={rowData}/> }
    </>
  
  )
}

export default WalletSidebar